var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.dimensions)},[_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }